<div class="drop-down-header">
  <ng-content></ng-content>
  @if (renderMode === 'drop-down' && showIcon) {
    <ftr-icon class="drop-down-header__caret" icon="ArrowDropDown"></ftr-icon>
  }
</div>
